import { Component, OnInit } from '@angular/core';
import { countries } from 'countries-list';
import { MobileService } from '../_services/mobile.service';
import { AccountService } from '../account.service';
import { TranslateService } from '@ngx-translate/core';
import { ToasterService } from 'angular2-toaster';
import { Router } from '@angular/router';
import { FirebaseService } from 'app/services/firebase.service';
import { AppConfigService } from 'app/services/app-config.service';
@Component({
  selector: 'app-reset-mobile-password',
  templateUrl: './reset-mobile-password.component.html',
  styleUrls: [
    './reset-mobile-password.component.scss',
    '../account.scss',
    '../container/container.component.scss'
  ]
})
export class ResetMobilePasswordComponent implements OnInit {
  loadingUserCountry = true;
  isSelectOpen = false;
  isLoading;

  phoneCode = '';
  phoneNumber = '';
  completePhoneNumber;

  verificationCode;

  countryList = [];

  chosenCountry = {
    capital: '',
    continent: '',
    currency: '',
    emoji: '',
    emojiU: '',
    languages: [],
    name: '',
    native: '',
    phone: ''
  };

  errors = {
    phone: '',
    code: '',
    password: '',
  };

  user = {
    password: '',
    username: '',
    passwordConfirmation: '',
  };

  step = 1;

  constructor(
    private mobileService: MobileService,
    public accountService: AccountService,
    private toasterService: ToasterService,
    private translate: TranslateService,
    private router: Router,
    private firebaseService: FirebaseService,
    private appConfigService: AppConfigService,
  ) {
    this.countryList = Object.keys(countries).map(function (personNamedIndex) {
      const country = countries[personNamedIndex];
      return country;
    });
   }

  ngOnInit() {
    const data = this.appConfigService.config.geo_info;
    this.chosenCountry = this.countryList.find(country => country.name === data['country_name']);
    this.phoneCode = '+' + this.chosenCountry.phone;
    this.loadingUserCountry = false;
  }

  toggleSelect() {
    this.isSelectOpen = !this.isSelectOpen;
  }

  handleSelect(country) {
    this.chosenCountry = country;
    this.phoneCode = `+${country.phone}`;
    this.phoneNumber = '';
    this.isSelectOpen = false;
  }

  sendResetMobilePassword() {
    this.completePhoneNumber = this.phoneCode + this.phoneNumber;
    const payload = { mobile_number: this.completePhoneNumber };
    this.accountService.reset(payload).subscribe(
      () => {
        this.step = 2;
      },
      err => {
        this.isLoading = false;
        if (err.status === 404) {
          this.translate
          .get('unknown_phone_number')
          .subscribe((res: string) => {
            this.errors.phone = res;
          });
        } else {
          this.errors.phone = 'Invalid number';
        }
      }
      );

  }
  verificationCodeSubmit() {
    this.mobileService.verifyMobileNumber(this.completePhoneNumber, this.verificationCode).subscribe(
      () => {
        this.step = 3;
      },
      err => {
        this.errors.code = 'Invalid code';
      }
      );
  }

  public isFormReady() {
    return (
      this.user.password &&
      this.user.password === this.user.passwordConfirmation &&
      !this.isLoading
    );
  }

  passwordsSubmit() {
    if (!this.isFormReady()) {
      return null;
    }
    const payload = {
      mobile_number: this.completePhoneNumber,
      code: this.verificationCode,
      password: this.user.password,
    };
    this.accountService.confirmPasswordReset(payload).subscribe(
      () => {
        this.translate
          .get('password_changed_successfully')
          .subscribe(message => {
            this.router.navigate(['/account/login']);
            this.toasterService.pop('success', undefined, message);
          });
        this.firebaseService.logEvent('login_password_reset', {});
      },
      data => {
        const error = data.error;
        this.isLoading = false;
        if (error.detail) {
          this.toasterService.pop('error', undefined, error.detail);
        }
        if (error.password) {
          this.errors.password = error.password;
        }
      }
    );
  }


}
